function shows(backendAxiosInstance) {
  async function getShowDetail(showId) {
    return backendAxiosInstance.get(`/contents/v1/shows/${showId}`, {
      includeLanguage: true
    });
  }
  async function getSeasonDetail(showId, seasonNumber) {
    return backendAxiosInstance.get(`/contents/v1/shows/${showId}/seasons/${seasonNumber}`, {
      includeLanguage: true
    });
  }
  return {
    getShowDetail,
    getSeasonDetail
  };
}

export { shows as default };
//# sourceMappingURL=shows.js.map
